module.exports = __webpack_public_path__ + "assets/img/dot.761670aa.png";